module.exports = __webpack_public_path__ + "static/logo-5920efc588caba73cfc80ee53e1a9ab5.svg";